/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Day_Short_4Inputs */

const he_statistics_day_short_4 = /** @type {(inputs: Statistics_Day_Short_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ה`)
};

const en_statistics_day_short_4 = /** @type {(inputs: Statistics_Day_Short_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T`)
};

/**
* | output |
* | --- |
* | "T" |
*
* @param {Statistics_Day_Short_4Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_day_short_4 = /** @type {((inputs?: Statistics_Day_Short_4Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Day_Short_4Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_day_short_4(inputs)
	return en_statistics_day_short_4(inputs)
});